export const ACTION_ISSUE = "0";
export const ACTION_WITHDRAW = "1";
export const ACTION_WRITEOFF = "2";
export const ACTION_RESTORE = "3";
export const ACTION_TRANSFER = "4";
